import baseAPI from '@/http'

const router = 'api/dashboard/dashboardadministrativo'

export const administrativeDashboardAPI = {
  getDashboard: (filter) => baseAPI.post(router, filter),
  getDashboardCities: (filter) => baseAPI.post(`${router}` + '/get-andamento-municipios', filter),
  getDashboardSolucoes: (id) => baseAPI.get(`${router + '/get-andamento-solucoes/' + id}`),
  getDashboardTarefas: (id) => baseAPI.get(`${router + '/get-andamento-tarefas/' + id}`),
  getPesquisa: (middleware, filter = {}) => baseAPI.post(`${router + `/` + middleware}`, filter),
  getResourceDashboard: (filter = {}) =>
    baseAPI.post(`${router}` + '/get-recursos-dashboard', filter),
  getAnaliticoPorIndicador: () => baseAPI.get(`${router}` + '/get-analitico-por-indicador'),
  downloadRefusedEvidence: (evidenceId) => baseAPI.get(`${router}` + '/download-evidencias-rejeitadas/' + evidenceId, { responseType: 'blob' }),
  getPerguntaEvidencia: (evidenceId) => baseAPI.get(`${router}` + '/get-evidencia/' + evidenceId),
  getResourceDashboardFilters: () => baseAPI.get(`${router}` + '/get-recursos-dashboard-filtros'),
  getResultadosIanMunicipios: (eligibility = 'ALL') =>
    baseAPI.get(`${router}` + `/resultados-ian/municipios?eligibility=${eligibility}`),
  getIanMemoriaCalculo: (municipioId) =>
    baseAPI.get(`${router}` + `/ian-memoria-calculo/${municipioId}`)

}
